import { getProductVariantKey } from './aggregateProductVariants';

export const isSameProductLink = (left, right) => (
  String(left?._id) === String(right?._id)
  && (left?.isDraft === true) === (right?.isDraft === true)
);

export const isSameVariantLink = (left, right) => {
  if (getProductVariantKey(left) !== getProductVariantKey(right)) return false;

  if (left?.type === 'listingVariant' || right?.type === 'listingVariant') {
    return (left?.isDraft === true) === (right?.isDraft === true);
  }

  return true;
};

export const matchesProductLinkFilter = (link, filter) => {
  if (!filter?._id || String(link?._id) !== String(filter._id)) return false;
  if (filter.isDraft === undefined) return true;
  return (link?.isDraft === true) === (filter.isDraft === true);
};

export const matchesVariantLinkFilter = (link, filter) => {
  if (!filter?.variantId) return false;
  if (!isSameVariantLink(link, filter)) return false;
  if (filter.type && link?.type !== filter.type) return false;
  return true;
};
